import { useContext, createContext } from 'react';
import noop from 'utils/noop';

export type JsonViewModeState = {
  isActive: boolean;
  isRawJson: boolean;
  toggleViewMode: () => void;
};

export const JsonViewModeContext = createContext<JsonViewModeState>({
  isActive: false,
  isRawJson: false,
  toggleViewMode: noop,
});

export const useJsonViewModeContext = () => useContext(JsonViewModeContext);
